'use strict';

var React = require('react');

var SvgMetaobjectMinor = function SvgMetaobjectMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m6.276 13.945-2.723-1.408a1.038 1.038 0 0 1-.553-.925v-6.993c0-.392.214-.75.553-.925l5-2.585a.97.97 0 0 1 .894 0l5 2.585c.339.175.553.533.553.925v2.414c0 .33-.337.542-.62.392a2.895 2.895 0 0 0-2.751.017l-3.129 1.707-.252.174a2.925 2.925 0 0 0-1.248 2.411v1.748c0 .385-.391.635-.724.463Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.526 9.114a1.04 1.04 0 0 1 .948 0l3 1.543c.324.167.526.49.526.842v4.002a.951.951 0 0 1-.526.842l-3 1.543a1.041 1.041 0 0 1-.948 0l-3-1.543a.951.951 0 0 1-.526-.843v-4.002c0-.351.202-.675.526-.842l3-1.543Z"
  }));
};

exports.SvgMetaobjectMinor = SvgMetaobjectMinor;
